import { apiRequest } from "../../../../shared/lib/api";

export type MyEventRegistrationItem = {
  id: number;
  eventId: string;
  tournamentId: number;
  registrationType?: "individual" | "fixed_pair";
  status: "pending" | "confirmed" | "canceled" | "waitlist";
  paymentRequired: boolean;
  paymentStatus: "pending" | "confirmed" | "canceled" | "refunded";
  paymentProvider?: string | null;
  paymentReference?: string | null;
  paymentAmountCents?: number | null;
  waitlistJoinedAt?: string | null;
  waitlistConfirmedAt?: string | null;
  waitlistPosition?: number | null;
  waitlistPromotedAt?: string | null;
  waitlistPromotionReason?: string | null;
  challengeName?: string | null;
  challengeType?: string | null;
  scheduledAt?: string | null;
  scheduledEndAt?: string | null;
  categoryGender?: string | null;
  category?: string | null;
  categoryMale?: string | null;
  categoryFemale?: string | null;
  paymentLink?: string | null;
  asaasPaymentId?: string | null;
  paymentMethod?: string | null;
  paymentConfirmedAt?: string | null;
  paymentCanceledAt?: string | null;
  teammateName?: string | null;
  teammateCpf?: string | null;
  createdAt?: string;
  updatedAt?: string;
};

export type MyPaymentItem = {
  id: number;
  sourceType: string;
  sourceId: string;
  registrationId?: number | null;
  eventId?: string | null;
  tournamentId?: number | null;
  challengeName?: string | null;
  challengeType?: string | null;
  scheduledAt?: string | null;
  scheduledEndAt?: string | null;
  amountCents: number;
  currency: string;
  status: "pending" | "confirmed" | "canceled" | "refunded";
  provider?: string | null;
  asaasPaymentId?: string | null;
  paymentMethod?: string | null;
  paymentLink?: string | null;
  externalReference?: string | null;
  createdAt?: string;
  confirmedAt?: string | null;
  canceledAt?: string | null;
};

export type MyGameSet = {
  setNumber: number | null;
  gamesA: number | null;
  gamesB: number | null;
  tieBreakA: number | null;
  tieBreakB: number | null;
  isMatchTieBreak: boolean;
  winnerSide: "A" | "B" | null;
};

export type MyGameItem = {
  matchId: number;
  tournamentId: number;
  tournamentName: string;
  tournamentAddress?: string | null;
  competitionType: "tournament";
  categoryKey?: string | null;
  categoryName?: string | null;
  roundNumber?: number | null;
  roundCode?: string | null;
  stage?: string | null;
  groupName?: string | null;
  matchNumber?: number | null;
  matchLabel: string;
  sideALabel?: string | null;
  sideBLabel?: string | null;
  userSide?: "A" | "B" | null;
  opponentLabel?: string | null;
  slotId?: number | null;
  slotStartAt?: string | null;
  slotEndAt?: string | null;
  actualStartedAt?: string | null;
  actualFinishedAt?: string | null;
  courtName?: string | null;
  matchStatus: string;
  status: "upcoming" | "history";
  winnerSide?: "A" | "B" | null;
  userResult?: "win" | "loss" | null;
  scoreLabel?: string;
  sets?: MyGameSet[];
  detailUrl: string;
};

export type MyGamesResponse = {
  upcoming: MyGameItem[];
  history: MyGameItem[];
  games: MyGameItem[];
};

export function listMyEventRegistrations(token: string) {
  return apiRequest<MyEventRegistrationItem[]>("/api/me/event-registrations", {
    headers: { Authorization: `Bearer ${token}` },
  });
}

export function cancelMyEventRegistration(token: string, id: number) {
  return apiRequest<{ ok: boolean; id: number }>(`/api/me/event-registrations/${id}`, {
    method: "PUT",
    headers: { Authorization: `Bearer ${token}` },
    body: JSON.stringify({ action: "cancel_registration" }),
  });
}

export function deleteMyEventRegistration(token: string, id: number) {
  return apiRequest<{ ok: boolean; id: number }>(`/api/me/event-registrations/${id}`, {
    method: "DELETE",
    headers: { Authorization: `Bearer ${token}` },
  });
}

export function listMyPayments(token: string) {
  return apiRequest<MyPaymentItem[]>("/api/me/payments", {
    headers: { Authorization: `Bearer ${token}` },
  });
}

export function listMyGames(token: string) {
  return apiRequest<MyGamesResponse>("/api/me/games", {
    headers: { Authorization: `Bearer ${token}` },
  });
}
